// @flow
import {
  UPDATE_WCC_LOADING,
  UPDATE_WCC_SUCCESS,
  UPDATE_WCC_ERROR,
} from '../actions/wellChildCheckActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case UPDATE_WCC_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case UPDATE_WCC_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case UPDATE_WCC_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/wellChildCheckReducer.js